// extracted by mini-css-extract-plugin
export var main = "_298219e4e5c732bd93f391f46c7a026c-css";